import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { css } from "./Theme";

const Button = props => {
  const variant = "primary";
  const styles = css({
    px: 3,
    py: 2,
    border: "1px solid",
    borderColor: "background.tertiary",
    borderRadius: 4,
    backgroundColor: props.active ? "background.tertiraty" : "background.primary",
    fontSize: 1,
    color: "font.secondary",
    float: "left",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "background.secondary"
    }
  });
  return ___EmotionJSX("button", _extends({
    css: styles
  }, props), props.children);
};

export default Button;